import { useMemo } from 'react';

import { useQueryState } from 'hooks/useQueryState';

import { useQueryGetIntegratedScheduleVersion } from 'api/queries/getIntegratedScheduleVersion.query';

import MainTable from 'components/common/Tables/MainTable/MainTable';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import classes from 'components/widgets/VersionSummary/VersionSummary.module.scss';
import { columns } from 'components/widgets/VersionSummary/VersionSummary.utils';

export const VersionSummary = () => {
    const [metaDataId] = useQueryState('metaDataId');
    const { data, isLoading, isFetching } = useQueryGetIntegratedScheduleVersion({
        fileMetaDataId: Number(metaDataId),
    });

    const version = useMemo(
        () =>
            data
                ? [
                      {
                          fileType: data.fileType,
                          contractName: data.contractName,
                          sourceFile: data.sourceFile,
                          versionName: data.versionName,
                          date: data.date,
                          uploadingUser: data.uploadingUser,
                          uploadedDate: data.uploadedDate,
                          baseline: data.isBaseline,
                          projectType: data.projectType,
                      },
                  ]
                : [],
        [data],
    );
    return (
        <WidgetWithTitle title={'Version Summary'}>
            <div className={classes.container}>
                <MainTable columns={columns} data={version} isLoading={isLoading || isFetching} />
            </div>
        </WidgetWithTitle>
    );
};
